import React from 'react';

const explorations = [
  { status: 'In practice', title: 'Agents as engineering collaborators', copy: 'Exploring agents that can investigate incidents, gather context, reason through evidence and recommend credible next actions.' },
  { status: 'Building', title: 'Turning saved knowledge into action', copy: 'Investigating how AI can transform passive reading and scattered notes into memory, priority and consistent execution.' },
  { status: 'Thinking about', title: 'Personalised learning that adapts', copy: 'How interview preparation and professional learning can respond to a person’s gaps, confidence and momentum—not just serve more content.' },
  { status: 'Always learning', title: 'Reliable intelligence', copy: 'Prompt orchestration, context engineering, evaluation and observability patterns that make AI systems useful beyond the demo.' }
];

const Explorations: React.FC = () => (
  <section id="explorations" className="explorations-section py-24">
    <div className="section-transition" aria-hidden="true"><span>Work in motion</span></div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="section-heading mb-14">
        <div><span className="section-eyebrow">Ideas & explorations / 04</span><h2 className="text-4xl md:text-6xl font-bold text-white mt-3">The questions I’m following now.</h2></div>
        <p className="section-heading-copy">Not every meaningful idea begins as a polished product. This is the living edge of my work: experiments, questions and directions still taking shape.</p>
      </div>
      <div className="exploration-grid">
        {explorations.map((item, index) => (
          <article className="exploration-card" key={item.title}>
            <div><span className="exploration-status"><i />{item.status}</span><span className="exploration-index">0{index + 1}</span></div>
            <h3>{item.title}</h3><p>{item.copy}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Explorations;
